module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-matomo/gatsby-browser.js'),
      options: {"plugins":[],"siteId":"153","matomoUrl":"https://piwik.hawaii.do","siteUrl":"https://rapport-annuel.rsrl.ch"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
